export enum EmailUnsubscribeText {
    YouAreNowUnsubscribed = "You're now unsubscribed",
    WeAreSorryToSeeYouGo = "We're sorry to see you go — you'll miss out on some of our exclusive offers and deal campaigns. We look forward to serving your future travels!",
    CopyrightFooter = "Copyright © 2024 Agoda.com, All rights reserved.",
}
